"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var protocolAdapter_1 = require("../protocolAdapter");
var payloads_1 = require("../payloads");
var payloadTransport_1 = require("../payloadTransport");
var browserWebSocket_1 = require("./browserWebSocket");
var nodeWebSocket_1 = require("./nodeWebSocket");
var utilities_1 = require("../utilities");
var webSocketTransport_1 = require("./webSocketTransport");
/**
 * Web socket based client to be used as streaming transport.
 */
var WebSocketClient = /** @class */ (function () {
    /**
     * Creates a new instance of the [WebSocketClient](xref:botframework-streaming.WebSocketClient) class.
     *
     * @param url The URL of the remote server to connect to.
     * @param requestHandler Optional [RequestHandler](xref:botframework-streaming.RequestHandler) to process incoming messages received by this server.
     * @param disconnectionHandler Optional function to handle the disconnection message.
     */
    function WebSocketClient(_a) {
        var url = _a.url, requestHandler = _a.requestHandler, _b = _a.disconnectionHandler, disconnectionHandler = _b === void 0 ? null : _b;
        this._url = url;
        this._requestHandler = requestHandler;
        this._disconnectionHandler = disconnectionHandler;
        this._requestManager = new payloads_1.RequestManager();
        this._sender = new payloadTransport_1.PayloadSender();
        this._sender.disconnected = this.onConnectionDisconnected.bind(this);
        this._receiver = new payloadTransport_1.PayloadReceiver();
        this._receiver.disconnected = this.onConnectionDisconnected.bind(this);
        this._protocolAdapter = new protocolAdapter_1.ProtocolAdapter(this._requestHandler, this._requestManager, this._sender, this._receiver);
    }
    /**
     * Establish a connection with no custom headers.
     *
     * @returns A promise that will not resolve until the client stops listening for incoming messages.
     */
    WebSocketClient.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ws, transport, ws, transport, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!utilities_1.doesGlobalWebSocketExist()) return [3 /*break*/, 2];
                        ws = new browserWebSocket_1.BrowserWebSocket();
                        return [4 /*yield*/, ws.connect(this._url)];
                    case 1:
                        _a.sent();
                        transport = new webSocketTransport_1.WebSocketTransport(ws);
                        this._sender.connect(transport);
                        this._receiver.connect(transport);
                        return [3 /*break*/, 6];
                    case 2:
                        ws = new nodeWebSocket_1.NodeWebSocket();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, ws.connect(this._url)];
                    case 4:
                        _a.sent();
                        transport = new webSocketTransport_1.WebSocketTransport(ws);
                        this._sender.connect(transport);
                        this._receiver.connect(transport);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        throw (new Error("Unable to connect client to Node transport."));
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Stop this client from listening.
     */
    WebSocketClient.prototype.disconnect = function () {
        this._sender.disconnect(new payloadTransport_1.TransportDisconnectedEvent('Disconnect was called.'));
        this._receiver.disconnect(new payloadTransport_1.TransportDisconnectedEvent('Disconnect was called.'));
    };
    /**
     * Task used to send data over this client connection.
     *
     * @param request The streaming request to send.
     * @returns A promise that will produce an instance of receive response on completion of the send operation.
     */
    WebSocketClient.prototype.send = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._protocolAdapter.sendRequest(request)];
            });
        });
    };
    WebSocketClient.prototype.onConnectionDisconnected = function (sender, args) {
        if (this._disconnectionHandler != null) {
            this._disconnectionHandler('Disconnected');
            return;
        }
        throw (new Error("Unable to re-connect client to Node transport for url " + this._url + ". Sender: '" + sender + "'. Args:' " + args));
    };
    return WebSocketClient;
}());
exports.WebSocketClient = WebSocketClient;
//# sourceMappingURL=webSocketClient.js.map